import { Route, Routes, RoutesProps, Outlet } from "react-router-dom";

import React, { Suspense } from "react";
import Main from "../components/Main";
import Footer from "../components/Footer/Footer";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import Investorforum from "../components/InvestorForum/Investorforum";
import Investorforumdetails from "../components/InvestorForum/Investorforumdetails";
import Networkhub from "../components/Networkhub/Networkhub";
import Listandexpand from "../components/Homepage/Listandexpand/Listandexpand";
import Sessionrequests from "../components/Sessiontimings/Sessionrequests";
import Profilenew from "../components/Profilenew/Profilenew";
import Chatmessage from "../components/Chatmessage/Chatmessage";
import Signupvendor from "../components/Signupvendor/Signupvendor";
import AnalysisPremium from "../components/Analysis/profile_analysis_premium";
import SessionRequest from "../components/Analysis/ai_loader";

const InvestorForumLayout = () => {
  const token = localStorage.getItem("access_token");
  const isLoggedIn = !!(token && token !== "undefined" && token !== "null" && token.trim() !== "");

  if (isLoggedIn) {
    return <Main />;
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", paddingTop: 0, marginTop: 0 }}>
      <div id="main-app" style={{ flex: "1 0 auto", display: "flex", flexDirection: "column", paddingTop: 0, marginTop: 0 }}>
        <div className="app-body" style={{ flex: 1, paddingTop: 0, marginTop: 0 }}>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/",
  };
  const Homepage = React.lazy(() => import("../components/Homepage/Homepage"));
  const CommonHomepage = React.lazy(
    () => import("../components/Homepage/CommonHomepage"),
  );
  const Login = React.lazy(() => import("../components/Login/Login"));

  const LinkedInCallback = React.lazy(
    () => import("../components/Login/LinkedInCallback"),
  );

  const RegisterINVESTOR = React.lazy(
    () => import("../components/Login/Registration_INVESTOR/Register_INVESTOR"),
  );
  const RegisterMentor = React.lazy(
    () => import("../components/Mentor/MentorRegister/MentorRegister"),
  );

  const CapitalBridgeRegistration = React.lazy(
    () => import("../components/Registration/CapitalBridge/CapitalBridgeRegistration"),
  );

  const GlobalConnectRegistration = React.lazy(
    () => import("../components/Registration/GlobalConnect/GlobalConnectRegistration"),
  );

  const InvestorRegistration = React.lazy(
    () => import("../components/Registration/Investor/InvestorRegistration"),
  );

 
  const RegisterWantToSell = React.lazy(
    () =>
      import("../components/Login/Register_Enterprenuer/Reg_Enterprneur_WantToSell/Register_WantToSell"),
  );
  const RegisterWantToGrow = React.lazy(
    () =>
      import("../components/Login/Register_Enterprenuer/Reg_Enterpreneur_WantToGrow/RegisterWantToGrow"),
  );
  const EntrepreneurLogin = React.lazy(
    () => import("../components/Login/EntrepreneurLogin"),
  );
  const MainLogin = React.lazy(() => import("../components/Login/MainLogin"));
  const AuthOptions = React.lazy(
    () => import("../components/Login/AuthOptions"),
  );
  const CreateNewPassword = React.lazy(
    () => import("../components/Login/CreateNewPassword"),
  );
  const Subscriptions = React.lazy(
    () => import("../components/Login/Subscription/Subscriptions"),
  );
  const SubscriptionPreview = React.lazy(
    () => import("../components/Login/Subscription/SubscriptionPreview"),
  );

  const Home = React.lazy(() => import("../components/Home/home"));
  const ForcePasswordChange = React.lazy(
    () => import("../components/Login/ForcePasswordChange"),
  );
  const Businesses = React.lazy(
    () => import("../components/Businesses/Businesses"),
  );
  const ProfileDetailsInvestment = React.lazy(
    () =>
      import("../components/Profile/New_MyProfile_Investment/ProfileDetails"),
  );
  const ProfileDetailsWantToSell = React.lazy(
    () =>
      import("../components/Profile/Profile_Enterprenur_wantToSell/ProfileDetailsWantToSell"),
  );
  const ProfileDetailsWantToGrow = React.lazy(
    () =>
      import("../components/Profile/Profile_Enterprenur_WantToGrow/ProfileDetailsWantToGrow"),
  );
  const ProfileDetails_Investor = React.lazy(
    () =>
      import("../components/Profile/New_MyProfile_Investor/ProfileDetails_INVESTOR"),
  );
  const ProfileReviewPage = React.lazy(
    () => import("../components/Profile/ProfileReviewPage"),
  );
  const SentProposals = React.lazy(
    () => import("../components/SentProposals/SentProposals"),
  );
  const MyProposals = React.lazy(
    () => import("../components/SentProposals/myProposals"),
  );
  const Chats = React.lazy(() => import("../components/Chats/ChatList"));
  const UserChat = React.lazy(() => import("../components/Chats/Chats"));
  const ProfileUnderReview = React.lazy(
    () => import("../components/Common/ProfileDetails/ProfileUnderReviewModal"),
  );

  const ProfileRejected = React.lazy(
    () => import("../components/Common/ProfileDetails/ProfileRejectedModal"),
  );

  const PrivacyPolicy = React.lazy(
    () => import("../components/PrivacyPolicy/PrivacyPolicy"),
  );
  const ContactSupport = React.lazy(
    () => import("../components/ContactSupport/ContactSupport"),
  );

  const BusinesCardDetail = React.lazy(
    () => import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );
  const CapitalBridgeCardDetails = React.lazy(
    () => import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );
  const DeleteAccount = React.lazy(
    () => import("../components/DeleteAccount/DeleteAccount"),
  );
  const CapitalBridge = React.lazy(
    () => import("../components/CapitalBridge/CapitalBridge"),
  );
  const BusinessExchange = React.lazy(
    () => import("../components/BusinessExchange/BusinessExchange"),
  );
  const BusinessExchnageCardDetails = React.lazy(
    () => import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );

  const InvestorCardDetails = React.lazy(
    () => import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );

  const GlobalConnectCardDetails = React.lazy(
    () => import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );

  const MySubscription = React.lazy(
    () => import("../components/MySubscription/MySubscription"),
  );

  const TransactionHistory = React.lazy(
    () => import("../components/MySubscription/TransactionHistory"),
  );

  const CountryList = React.lazy(
    () => import("../components/MySubscription/CountryList"),
  );
  const SubscriptionHistory = React.lazy(
    () => import("../components/MySubscription/SubscriptionHistory"),
  );
  const Sessiontimings = React.lazy(
    () => import("../components/Mentor/MentorSessionCalendar/MentorSessionCalendar"),
  );
  const MentorChangePassword = React.lazy(
    () => import("../components/Mentor/MentorChangePassword/MentorChangePassword"),
  );
  const MentorCustomerDetailsPage = React.lazy(
    () => import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );
  const MentorSessionRequestsPage = React.lazy(
    () => import("../components/Mentor/MentorSessionRequests/MentorSessionRequests"),
  );
  const MentorProfilePage = React.lazy(
    () => import("../components/Mentor/MentorProfile/MentorProfile"),
  );
  const MentorEditProfilePage = React.lazy(
    () => import("../components/Mentor/MentorEditProfile/MentorEditProfile"),
  );
  const MentorConnectPage = React.lazy(
    () => import("../components/Homepage/MentorConnect/MentorConnect"),
  );
  const TrustedMentorsList = React.lazy(
    () => import("../components/Homepage/MentorConnect/TrustedMentorsList"),
  );
  const MentorConnectDetailPage = React.lazy(
    () => import("../components/Homepage/MentorConnect/MentorConnectDetail"),
  );
  const MentorChatsListPage = React.lazy(
    () => import("../components/MentorChats/MentorChats"),
  );
  const MentorEarningsPage = React.lazy(
    () => import("../components/Mentor/MentorEarnings/MentorEarnings"),
  );
  const MySessionsPage = React.lazy(
    () => import("../components/MySessions/MySessions"),
  );
  const GuestSessionPage = React.lazy(
    () => import("../components/GuestSession/GuestSession"),
  );
  const LiveKitSessionPage = React.lazy(
    () => import("../components/LiveKitSession/LiveKitSession"),
  );
  const EgressTemplatePage = React.lazy(
    () => import("../components/EgressTemplate/EgressTemplate"),
  );
  const HomePage = React.lazy(() => import("../components/Homepage/Homepage"));
  const FeaturedBusiness = React.lazy(
    () => import("../components/Homepage/FeatureBusinesses"),
  );
  const StartupForInvestor = React.lazy(
    () => import("../components/Homepage/StartupsForInvestor"),
  );
  const FeaturedInvestors = React.lazy(
    () => import("../components/Homepage/FeatureInvestors"),
  );
  const FindStartups = React.lazy(
    () => import("../components/Homepage/FindStartup/FindStartups"),
  );
  const PortfolioExpansion = React.lazy(
    () =>
      import("../components/Homepage/PortfolioExpansion/PortFolioExpansion"),
  );
  const FundFinding = React.lazy(
    () => import("../components/Homepage/Fundfunding/Fundfinding"),
  );

  const ListAndExpand = React.lazy(
    () => import("../components/Homepage/Listandexpand/Listandexpand"),
  );

  const FundingOpportunities = React.lazy(
    () =>
      import("../components/Homepage/FundingOpportunities/FundingOpportunities"),
  );
  const Smartinsights = React.lazy(
    () => import("../components/Homepage/Smartinsights/Smartinsights"),
  );
  const GloablOpportunities = React.lazy(
    () =>
      import("../components/Homepage/GlobalOpportunities/GlobalOpportunities"),
  );
  const GlobalConnectDetails = React.lazy(
    () =>
      import("../components/Mentor/MentorCustomerDetails/MentorCustomerDetails"),
  );
  const PaymentStatus = React.lazy(
    () => import("../components/PaymentStatus/PaymentStatus"),
  );
  const PostRequirement = React.lazy(
    () => import("../components/Networkhub/PostRequirement"),
  );
  const RequirementDetailPage = React.lazy(
    () => import("../components/Networkhub/RequirementDetailPage"),
  );
  const MyRequirementDetailPage = React.lazy(
    () => import("../components/Networkhub/MyRequirementDetailPage"),
  );
  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/homepage"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Homepage />
                </Suspense>
              </PublicRoute>
            }
          />
          <Route
            path="/linkedin/callback"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <LinkedInCallback />
                </Suspense>
              </PublicRoute>
            }
          />

          <Route
            path="/profilenew"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Profilenew />
                </Suspense>
              </PublicRoute>
            }
          />
          <Route
            path="/chatmessage"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Chatmessage />
                </Suspense>
              </PublicRoute>
            }
          />
          <Route
            path="/signupvendor"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Signupvendor />
                </Suspense>
              </PublicRoute>
            }
          />



          <Route
            path="/listandexpand"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Listandexpand />
                </Suspense>
              </PublicRoute>
            }
          />

          {/* <Route
            path="/mentor/sessiontimings"
            element={ 
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Sessiontimings />
                </Suspense>
              </PublicRoute>
            }
          /> */}
          <Route
            path="/sessionrequests"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Sessionrequests />
                </Suspense>
              </PublicRoute>
            }
          />

          <Route
            path="/"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <CommonHomepage />
                </Suspense>
              </PublicRoute>
            }
          />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Login />
                </Suspense>
              </PublicRoute>
            }
          />

          <Route
            path="/get-started"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <Login />
                </Suspense>
              </PublicRoute>
            }
          />

          <Route
            path="/delete-account"
            element={
              <Suspense fallback={<></>}>
                <DeleteAccount />
              </Suspense>
            }
          />

          <Route
            path="/:login_type/login"
            element={
              <Suspense fallback={<></>}>
                <MainLogin />
              </Suspense>
            }
          />
          {/* Standalone (no Header/Footer) — mandatory first-login password change. */}
          <Route
            path="/change-password"
            element={
              <Suspense fallback={<></>}>
                <ForcePasswordChange />
              </Suspense>
            }
          />
          <Route
            path="/mentor/register"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <RegisterMentor />
              </Suspense>
            }
          />
          <Route
            path="/mentor/change-password"
            element={
              <Suspense fallback={<></>}>
                <MentorChangePassword />
              </Suspense>
            }
          />
          <Route
            path="/mentor/schedule-sessions"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <Sessiontimings />
              </Suspense>
            }
          />
          <Route
            path="/mentor/session-requests"
            element={
              <Suspense fallback={<></>}>
                <MentorSessionRequestsPage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/customer/:uuid"
            element={
              <Suspense fallback={<></>}>
                <MentorCustomerDetailsPage />
              </Suspense>
            }
          />
          {/* In-app LiveKit video call (full-screen, standalone). Customer +
              mentor variants call their role-correct token endpoint. */}
          <Route
            path="/session/:uuid"
            element={
              <Suspense fallback={<></>}>
                <LiveKitSessionPage role="customer" />
              </Suspense>
            }
          />
          <Route
            path="/guest-session/:uuid"
            element={
              <Suspense fallback={<></>}>
                <GuestSessionPage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/session/:uuid"
            element={
              <Suspense fallback={<></>}>
                <LiveKitSessionPage role="mentor" />
              </Suspense>
            }
          />
          {/* LiveKit Egress recording template — loaded only by the egress
              recorder (headless Chrome), never by humans. Standalone: no app
              header/guard; auth is the recorder token in the query string. */}
          <Route
            path="/egress-template"
            element={
              <Suspense fallback={<></>}>
                <EgressTemplatePage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/my-profile"
            element={
              <Suspense fallback={<></>}>
                <MentorProfilePage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/my-profile/edit"
            element={
              <Suspense fallback={<></>}>
                <MentorEditProfilePage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/earnings"
            element={
              <Suspense fallback={<></>}>
                <MentorEarningsPage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/chats"
            element={
              <Suspense fallback={<></>}>
                <MentorChatsListPage />
              </Suspense>
            }
          />
          <Route
            path="/mentor/chats/:uuid"
            element={
              <Suspense fallback={<></>}>
                <MentorChatsListPage />
              </Suspense>
            }
          />

          <Route
            path="/:login_type/register"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <RegisterINVESTOR />
              </Suspense>
            }
          />

          <Route
            path="/:login_type/subscriptions"
            element={
              <Suspense fallback={<></>}>
                <Subscriptions />
              </Suspense>
            }
          />
          {/* ProfileAnalysisSmart kept aside for now */}
          {/*
          <Route
            path="/:login_type/:account_type/profile-analysis-smart"
            element={
              <Suspense fallback={<></>}>
                <ProfileAnalysisSmart />
              </Suspense>
            }
          />
          */}
          <Route
            path="/:login_type/:account_type/profile-analysis"
            element={
              <Suspense fallback={<></>}>
                <AnalysisPremium />
              </Suspense>
            }
          />
          <Route
            path="/:login_type/profile-analysis"
            element={
              <Suspense fallback={<></>}>
                <AnalysisPremium />
              </Suspense>
            }
          />
          <Route
            path="/session-request"
            element={
              <Suspense fallback={<></>}>
                <SessionRequest />
              </Suspense>
            }
          />
          <Route
            path="/:login_type/:account_type/plan-preview"
            element={
              <Suspense fallback={<></>}>
                <SubscriptionPreview />
              </Suspense>
            }
          />
          <Route
            path="/:login_type/:account_type/subscriptions"
            element={
              <Suspense fallback={<></>}>
                <Subscriptions />
              </Suspense>
            }
          />

          <Route
            path="/:login_type/type"
            element={
              <Suspense fallback={<></>}>
                <EntrepreneurLogin />
              </Suspense>
            }
          />
          <Route
            path="/:login_type/:account_type/options"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <AuthOptions />
                </Suspense>
              </PublicRoute>
            }
          />
          <Route
            path="/:login_type/options"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <AuthOptions />
                </Suspense>
              </PublicRoute>
            }
          />
          <Route
            path="/:login_type/:account_type/login"
            element={
              <PublicRoute>
                <Suspense fallback={<></>}>
                  <MainLogin />
                </Suspense>
              </PublicRoute>
            }
          />

          <Route
            path="/create-new-password"
            element={
              <Suspense fallback={<></>}>
                <CreateNewPassword />
              </Suspense>
            }
          />

          <Route
            path="/capital-bridge-registration"
            element={
              <Suspense fallback={<></>}>
                <CapitalBridgeRegistration />
              </Suspense>
            }
          />
          <Route
            path="/global-connect-registration"
            element={
              <Suspense fallback={<></>}>
                <GlobalConnectRegistration />
              </Suspense>
            }
          />
          <Route
            path="/investor-registration"
            element={
              <Suspense fallback={<></>}>
                <InvestorRegistration />
              </Suspense>
            }
          />
          <Route
            path="/investor/register"
            element={
              <Suspense fallback={<></>}>
                <InvestorRegistration />
              </Suspense>
            }
          />
          <Route
            path="/entrepreneur/investment/register"
            element={
              <Suspense fallback={<></>}>
                <CapitalBridgeRegistration />
              </Suspense>
            }
          />
          <Route
            path="/entrepreneur/want-to-grow/register"
            element={
              <Suspense fallback={<></>}>
                <GlobalConnectRegistration />
              </Suspense>
            }
          />
          <Route
            path="/entrepreneur/want-to-sell/register"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <RegisterWantToSell />
              </Suspense>
            }
          />
          <Route
            path="/entrepreneur/want-to-grow/register"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <RegisterWantToGrow />
              </Suspense>
            }
          />
          <Route
            path="/:login_type/:account_type/subscriptions"
            element={
              <Suspense fallback={<></>}>
                <Subscriptions />
              </Suspense>
            }
          />

          <Route element={<InvestorForumLayout />}>
            <Route
              path="/guest/mentor-connect"
              element={
                <Suspense fallback={<></>}>
                  <MentorConnectPage guest />
                </Suspense>
              }
            />
            <Route
              path="/guest/mentor-connect/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <MentorConnectDetailPage guest />
                </Suspense>
              }
            />
            <Route
              path="/investor-forum"
              element={
                <Suspense fallback={<></>}>
                  <Investorforum />
                </Suspense>
              }
            />
            <Route
              path="/investor-forum/info"
              element={
                <Suspense fallback={<></>}>
                  <Investorforum />
                </Suspense>
              }
            />

            <Route
              path="/network-hub"
              element={
                <Suspense fallback={<></>}>
                  <Networkhub />
                </Suspense>
              }
            />

            <Route
              path="/network-hub/post-requirement"
              element={
                <Suspense fallback={<></>}>
                  <PostRequirement />
                </Suspense>
              }
            />
            <Route
              path="/network-hub/requirement/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <RequirementDetailPage />
                </Suspense>
              }
            />
            <Route
              path="/network-hub/my-requirement/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <MyRequirementDetailPage />
                </Suspense>
              }
            />
            <Route
              path="/network-hub/my-requirements/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <MyRequirementDetailPage />
                </Suspense>
              }
            />
            <Route
              path="/network-hub/detail/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <RequirementDetailPage />
                </Suspense>
              }
            />
            <Route
              path="/investor-forum-details/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <Investorforumdetails />
                </Suspense>
              }
            />
            <Route
              path="/investor-forum/info/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <Investorforumdetails />
                </Suspense>
              }
            />
            <Route
              path="/payment-status"
              element={
                <Suspense fallback={<></>}>
                  <PaymentStatus />
                </Suspense>
              }
            />
            <Route
              path="/contact-support"
              element={
                <Suspense fallback={<></>}>
                  <ContactSupport />
                </Suspense>
              }
            />
          </Route>

          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >
            <Route
              path="/:login_type/:account_type/investors/:id"
              element={
                <Suspense fallback={<></>}>
                  <InvestorCardDetails type="INVESTOR" />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/options"
              element={
                <PublicRoute>
                  <Suspense fallback={<></>}>
                    <AuthOptions />
                  </Suspense>
                </PublicRoute>
              }
            />

            <Route
              path="/profile-under-review"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <ProfileUnderReview />
                </Suspense>
              }
            />

            <Route
              path="/profile-rejected"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <ProfileRejected />
                </Suspense>
              }
            />
            <Route
              path="/investor/chats/:id"
              element={
                <Suspense fallback={<></>}>
                  <UserChat />
                </Suspense>
              }
            />

            <Route
              path="/global-connect/:id"
              element={
                <Suspense fallback={<></>}>
                  <GlobalConnectCardDetails type="WANT_TO_GROW" />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/home"
              element={
                <Suspense fallback={<></>}>
                  <HomePage />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/home"
              element={
                <Suspense fallback={<></>}>
                  <HomePage />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/startups"
              element={
                <Suspense fallback={<></>}>
                  <FindStartups />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/portfolio-expansion"
              element={
                <Suspense fallback={<></>}>
                  <PortfolioExpansion />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/:account_type/fund-finding"
              element={
                <Suspense fallback={<></>}>
                  <FundFinding />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/trusted-mentors"
              element={
                <Suspense fallback={<></>}>
                  <TrustedMentorsList />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/trusted-mentors"
              element={
                <Suspense fallback={<></>}>
                  <TrustedMentorsList />
                </Suspense>
              }
            />
            <Route
              path="/mentor/mentor-connect"
              element={
                <Suspense fallback={<></>}>
                  <MentorConnectPage />
                </Suspense>
              }
            />
            <Route
              path="/mentor/mentor-connect/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <MentorConnectDetailPage />
                </Suspense>
              }
            />
            <Route
              path="/my-sessions"
              element={
                <Suspense fallback={<></>}>
                  <MySessionsPage />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/smart-insight"
              element={
                <Suspense fallback={<></>}>
                  <Smartinsights />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/smart-insight/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <GlobalConnectDetails type="WANT_TO_GROW" />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/smart-insight"
              element={
                <Suspense fallback={<></>}>
                  <Smartinsights />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/global-opportunities"
              element={
                <Suspense fallback={<></>}>
                  <GloablOpportunities />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/global-opportunities"
              element={
                <Suspense fallback={<></>}>
                  <GloablOpportunities />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/funding-opportunities"
              element={
                <Suspense fallback={<></>}>
                  <FundingOpportunities />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/:account_type/list-and-expand"
              element={
                <Suspense fallback={<></>}>
                  <ListAndExpand />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/global-connect"
              element={
                <Suspense fallback={<></>}>
                  <Businesses />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/featured-businesses"
              element={
                <Suspense fallback={<></>}>
                  <FeaturedBusiness />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/featured-startups"
              element={
                <Suspense fallback={<></>}>
                  <StartupForInvestor isHomePage={false} />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/featured-startups"
              element={
                <Suspense fallback={<></>}>
                  <StartupForInvestor isHomePage={false} />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/featured-investors"
              element={
                <Suspense fallback={<></>}>
                  <FeaturedInvestors isHomePage={false} />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/investors"
              element={
                <Suspense fallback={<></>}>
                  <Home />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/capital-bridge"
              element={
                <Suspense fallback={<></>}>
                  <CapitalBridge />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/capital-bridge/:id"
              element={
                <Suspense fallback={<></>}>
                  <CapitalBridgeCardDetails type="INVESTMENT" />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/business-exchange"
              element={
                <Suspense fallback={<></>}>
                  <BusinessExchange />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/business-exchange/:id"
              element={
                <Suspense fallback={<></>}>
                  <BusinessExchnageCardDetails type="WANT_TO_SELL" />
                </Suspense>
              }
            />

            <Route
              path="/entrepreneur/investment/my-profile"
              element={
                <Suspense fallback={<></>}>
                  <ProfileDetailsInvestment />
                </Suspense>
              }
            />

            <Route
              path="/entrepreneur/want-to-sell/my-profile"
              element={
                <Suspense fallback={<></>}>
                  <ProfileDetailsWantToSell />
                </Suspense>
              }
            />

            <Route
              path="/entrepreneur/investment/profile-review"
              element={
                <Suspense fallback={<></>}>
                  <ProfileReviewPage type="investment" />
                </Suspense>
              }
            />

            <Route
              path="/entrepreneur/want-to-sell/profile-review"
              element={
                <Suspense fallback={<></>}>
                  <ProfileReviewPage type="want-to-sell" />
                </Suspense>
              }
            />
            <Route
              path="/entrepreneur/want-to-grow/profile-review"
              element={
                <Suspense fallback={<></>}>
                  <ProfileReviewPage type="want-to-grow" />
                </Suspense>
              }
            />
            <Route
              path="/entrepreneur/want-to-grow/my-profile"
              element={
                <Suspense fallback={<></>}>
                  <ProfileDetailsWantToGrow />
                </Suspense>
              }
            />
            <Route
              path="/investor/profile-review"
              element={
                <Suspense fallback={<></>}>
                  <ProfileReviewPage type="investor" />
                </Suspense>
              }
            />
            <Route
              path="/investor/my-profile"
              element={
                <Suspense fallback={<></>}>
                  <ProfileDetails_Investor />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/:account_type/my-subscription"
              element={
                <Suspense fallback={<></>}>
                  <MySubscription />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/transaction-history"
              element={
                <Suspense fallback={<></>}>
                  <TransactionHistory />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/subscription-history"
              element={
                <Suspense fallback={<></>}>
                  <SubscriptionHistory />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/:account_type/manage-country/:transId"
              element={
                <Suspense fallback={<></>}>
                  <CountryList />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/my-subscription"
              element={
                <Suspense fallback={<></>}>
                  <MySubscription />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/businesses/:id"
              element={
                <Suspense fallback={<></>}>
                  <BusinesCardDetail type="WANT_TO_GROW" />
                </Suspense>
              }
            />
            <Route
              path="/:login_type/:account_type/businesses/:id"
              element={
                <Suspense fallback={<></>}>
                  <BusinesCardDetail type="WANT_TO_GROW" />
                </Suspense>
              }
            />

            <Route
              path="/:login_type/:account_type/sent-proposals"
              element={
                <Suspense fallback={<></>}>
                  <SentProposals />
                </Suspense>
              }
            />
            <Route
              path="/investor/my-proposals"
              element={
                <Suspense fallback={<></>}>
                  <MyProposals />
                </Suspense>
              }
            />

            <Route
              path="investor/my-proposal/capital-bridge/:id"
              element={
                <Suspense fallback={<></>}>
                  <CapitalBridgeCardDetails type="INVESTMENT" />
                </Suspense>
              }
            />

            <Route
              path="/investor/my-proposal/business-exchange/:id"
              element={
                <Suspense fallback={<></>}>
                  <BusinessExchnageCardDetails type="WANT_TO_SELL" />
                </Suspense>
              }
            />
            <Route
              path="/investor/my-proposal/global-connect/:id"
              element={
                <Suspense fallback={<></>}>
                  <GlobalConnectCardDetails type="WANT_TO_GROW" />
                </Suspense>
              }
            />
            <Route
              path="/entrepreneur/:account_type/chats"
              element={
                <Suspense fallback={<></>}>
                  <Chats />
                </Suspense>
              }
            />
            <Route
              path="/investor/chats"
              element={
                <Suspense fallback={<></>}>
                  <Chats />
                </Suspense>
              }
            />
            <Route
              path="/global-connect/chats"
              element={
                <Suspense fallback={<></>}>
                  <Chats />
                </Suspense>
              }
            />
            <Route
              path="/entrepreneur/:account_type/chats/:id"
              element={
                <Suspense fallback={<></>}>
                  <UserChat />
                </Suspense>
              }
            />

            <Route
              path="/privacy-policy"
              element={
                <Suspense fallback={<></>}>
                  <PrivacyPolicy />
                </Suspense>
              }
            />
            <Route
              path="/profile-analysis"
              element={
                <Suspense fallback={<></>}>
                  <AnalysisPremium />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
